import NodeIndex from './NodeIndex'

class DocumentIndex extends NodeIndex {}

export default DocumentIndex
